import { EVENTS } from "Constanst";
import { FC } from "react";

export const ExportButton: FC = () => {
    const handleClick = () => {
        window.dispatchEvent(new CustomEvent(EVENTS.EXPORT_BUTTON_CLICKED));
    };
    return <img alt="export" style={{ cursor: "pointer" }} onClick={() => handleClick()} src="/images/menu-icon/EXPORT.svg" />;
};
